import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetAgrariansPublicQueryResponse, GetAgrariansPublic400, GetAgrariansPublic401, GetAgrariansPublic403, GetAgrariansPublic422, GetAgrariansPublic429, GetAgrariansPublic500 } from "../types/GetAgrariansPublic";

export const getAgrariansPublicQueryKey = () =>     [{url:`/api/purchase-tenders/pub/v1/agrarians`}] as const;
      export function getAgrariansPublicQueryOptions <TData = GetAgrariansPublicQueryResponse, TError = GetAgrariansPublic400 | GetAgrariansPublic401 | GetAgrariansPublic403 | GetAgrariansPublic422 | GetAgrariansPublic429 | GetAgrariansPublic500>(options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getAgrariansPublicQueryKey();

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/purchase-tenders/pub/v1/agrarians`,
              
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/purchase-tenders/pub/v1/agrarians
 */

export function useGetAgrariansPublic <TData = GetAgrariansPublicQueryResponse, TError = GetAgrariansPublic400 | GetAgrariansPublic401 | GetAgrariansPublic403 | GetAgrariansPublic422 | GetAgrariansPublic429 | GetAgrariansPublic500>(options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getAgrariansPublicQueryKey();

  const query = useQuery<TData, TError>({
    ...getAgrariansPublicQueryOptions<TData, TError>(clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
